import { Card, CardContent } from '@estac1/ui';

interface MetricCardProps {
  label: string;
  value: string;
  hint?: string;
  tone?: 'success' | 'danger';
}

export const MetricCard = ({ label, value, hint, tone }: MetricCardProps) => (
  <Card>
    <CardContent className="space-y-1 pt-6">
      <p className="text-xs font-medium uppercase tracking-wide text-muted-fg">{label}</p>
      <p
        className={
          tone === 'success'
            ? 'text-2xl font-semibold tabular-nums text-success'
            : tone === 'danger'
              ? 'text-2xl font-semibold tabular-nums text-danger'
              : 'text-2xl font-semibold tabular-nums'
        }
      >
        {value}
      </p>
      {hint && <p className="text-xs text-muted-fg">{hint}</p>}
    </CardContent>
  </Card>
);
